import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UploadedFileModel } from '@app/shared/components/file-upload/models/uploaded-file.model';

@Injectable()
export class ImportPcardService {
	private readonly endpointBase = '/api/invoice/import';

	constructor(private readonly http: HttpClient) {}

	import(entity: UploadedFileModel): Observable<any> {
		return this.http.post(`${this.endpointBase}`, entity);
	}
}
